var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLocation2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#6C9BD2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.66996 8.00004L6.89996 8.74004C6.93602 8.74947 6.96893 8.76834 6.99529 8.7947C7.02165 8.82106 7.04052 8.85397 7.04996 8.89004L8.04996 12.32C8.06353 12.3624 8.09021 12.3994 8.12615 12.4256C8.1621 12.4519 8.20545 12.466 8.24996 12.466C8.29446 12.466 8.33781 12.4519 8.37376 12.4256C8.4097 12.3994 8.43639 12.3624 8.44996 12.32L11.26 4.88004C11.2754 4.84286 11.2799 4.80201 11.2728 4.76237C11.2657 4.72273 11.2474 4.68597 11.22 4.65646C11.1926 4.62695 11.1573 4.60594 11.1182 4.59594C11.0792 4.58594 11.0382 4.58736 11 4.60003L3.61996 7.60003C3.5832 7.62191 3.55361 7.65402 3.53482 7.69245C3.51603 7.73087 3.50884 7.77394 3.51415 7.81639C3.51946 7.85883 3.53702 7.89881 3.56469 7.93142C3.59236 7.96404 3.62894 7.98788 3.66996 8.00004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation2);
export default __webpack_public_path__ + "static/media/icon_location_2.00e95f1997e929b2b1a6dd786df6983a.svg";
export { ForwardRef as ReactComponent };